import { render, staticRenderFns } from "./CompSelectBox.vue?vue&type=template&id=59873e2a&"
import script from "./CompSelectBox.vue?vue&type=script&lang=ts&"
export * from "./CompSelectBox.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports